<template>
   <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">

      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        

        <el-form-item label="门店名称/ID"><el-input size="small" v-model="searchForm.name" placeholder="门店名称/ID"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!--内容-->
    <div class="product-content">
      <div>不计算取消订单</div>
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"   >
          <el-table-column prop="store_id" label="门店ID"></el-table-column>
          <el-table-column prop="store_name" label="门店名称" ></el-table-column>
          <el-table-column prop="sales" label="销售总业绩"></el-table-column>
          <!-- <el-table-column prop="canel_sales" label="销售取消业绩"></el-table-column> -->
          <el-table-column prop="hx_sales" label="核销业绩"></el-table-column>
          <el-table-column prop="hx_no_sales" label="未核销业绩"></el-table-column>
          <!-- <el-table-column prop="sales_num" label="销量"></el-table-column> -->
          
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

  </div>
</template>

<script>
  import StatisticsApi from '@/api/statistics.js';
  export default{
    components:{
    },
    data(){
      return{
        /*是否正在加载*/
        activeName: 'type7',
        loading: true,
        tableData:[],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          product_name: '',
          supply_key: '',
        },
        /*数据对象*/
        dataModel:{}
      }
    },
    provide: function () {
      return {
        dataModel: this.dataModel
      }
    },
    created() {

      this.getData();
    },
    methods:{
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },

      /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getData();
      },

      /*获取数据*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.type = self.activeName;
        self.loading = true;
        StatisticsApi.getStore(Params, true)
          .then(res => {
            self.tableData = res.data.list.data;
            self.totalDataNumber = res.data.list.total;
            self.loading = false;
          })
          .catch(error => {});
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/store/index.vue